import React, { ReactNode } from 'react';
import styles from './OrderCard.module.css';
import CloseIcon from '@mui/icons-material/Close';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PersonIcon from '@mui/icons-material/Person';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { formatDocument, formatDateSafely } from '../../../utils/formatters';

// Interface deve ser adaptada para o tipo de Order que você usa no projeto
// Como o Order original é muito grande, vou definir uma interface mínima compatível aqui
// ou importar a original se disponível. Vou assumir a estrutura que vi nos códigos anteriores.
export interface OrderCardProps {
    order: {
        id?: number | string;
        code: string | number;
        segment?: string;
        clientName: string;
        clientCnpj: string;
        emissionDate: string;
    } | null;
    onRemove?: () => void;
    onViewDetails?: () => void; // New prop for viewing full order details
    children?: ReactNode; // Para botões de ação na revisão
}

const OrderCard: React.FC<OrderCardProps> = ({ order, onRemove, onViewDetails, children }) => {
    if (!order) return null;

    return (
        <div className={styles.selectedCard}>
            {onRemove && (
                <button className={styles.removeButton} onClick={onRemove} title="Alterar Pedido">
                    <CloseIcon fontSize="small" />
                </button>
            )}

            {/* Header com Pedido e Segmento */}
            <div className={styles.cardHeader}>
                <div className={styles.orderNumber}>
                    <div className={styles.iconWrapper}>
                        <ReceiptIcon className={styles.headerIcon} />
                    </div>
                    <div>
                        <div className={styles.orderLabel}>Pedido</div>
                        <div className={styles.orderCode}>{order.code}</div>
                    </div>
                </div>
                {order.segment && (
                    <div className={styles.segmentTag}>
                        <LocalOfferIcon fontSize="small" />
                        <span>{order.segment}</span>
                    </div>
                )}
            </div>

            {/* Informações do Cliente */}
            <div className={styles.cardSection}>
                <div className={styles.iconWrapper}>
                    <PersonIcon fontSize="small" className={styles.sectionIconMui} />
                </div>
                <div className={styles.sectionContent}>
                    <div className={styles.cardLabel}>Cliente</div>
                    <div className={styles.cardValue}>{order.clientName}</div>
                    <div className={styles.cardSubtext}>{formatDocument(order.clientCnpj)}</div>
                </div>
            </div>

            {/* Datas */}
            <div className={styles.cardDates}>
                <div className={styles.dateItem}>
                    <div className={styles.iconWrapper}>
                        <CalendarTodayIcon fontSize="small" className={styles.dateIcon} />
                    </div>
                    <div>
                        <div className={styles.cardLabel}>Emissão</div>
                        <div className={styles.cardValue}>
                            {formatDateSafely(order.emissionDate)}
                        </div>
                    </div>
                </div>

                {onViewDetails && (
                    <button className={styles.viewLink} onClick={onViewDetails} type="button">
                        Visualizar Pedido
                    </button>
                )}
            </div>

            {/* Ações (Botões da Revisão) */}
            {children && (
                <div className={styles.cardActions}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default OrderCard;
